// extracted by mini-css-extract-plugin
module.exports = {"forecastSummary":"Forecast_forecastSummary__3rCwS"};